var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4680 3120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4680,
    height: 3120,
    fill: "#fff",
    "data-name": 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cacafe",
    d: "M3800.41,1470.65c24.79-141.27,16.53-301.29-14.6-440.13-42.49-189.56-140.35-365.09-281.34-472.1-219.7-166.73-512.69-147.1-755.37-32.41-101.64,48-200.09,112-308.95,128.13-158.77,23.58-313.3-57.09-468-105.49-210.53-65.87-441.65-70.76-640.29,33.22-225.22,117.89-385.36,384-366.65,677.14,8.47,132.81,51.84,263.88,36.49,395.82-15.57,133.82-83,245.77-118.71,371.8-48.73,172,65.42,529.44,274.65,599.38l2212.76,2.16c361.85-21.44,412.23-67.19,444.5-243.82,32.72-179-68.77-272.1-81-448.14C3722.33,1769.55,3772.55,1629.38,3800.41,1470.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112e41",
    d: "M3241.41,2615.82l4.54,5.3c216.79-232.16,307.08-586.84,308-590.39l-6.92-.91C3546.11,2033.35,3456.41,2385.59,3241.41,2615.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#318971",
    d: "M3615.21,1661.8c-59.23,152.23-71.8,376.35-71.8,376.35,148.3-228.53,138.1-508.37,138.1-508.37A795.44,795.44,0,0,0,3615.21,1661.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47b971",
    d: "M3623.46,1768.62c2.16-133.41,58.05-238.84,58.05-238.84-121.2,164.36-208.12,656.5-208.12,656.5C3640,2000.54,3621.3,1902,3623.46,1768.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70d271",
    d: "M3705.09,1755.65c-55.37,87.24-27.84,111.57-92.62,235.87-71.2,136.61-122.55,141.94-190.92,274.95-59.78,116.31-89,245.57-68.6,253.58,0,0,78.52-132.48,229.12-302.75,152.33-172.21,229.65-180.62,268.75-292.68,34.09-97.72-5.4-146.67,46.95-245.24,45.67-86,111.54-116.21,108.54-128C4001.3,1531.59,3809.91,1590.5,3705.09,1755.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47b971",
    d: "M3353,2520.05s229.06-204.69,453.58-517.91C3806.53,2002.14,3530.14,2183.79,3353,2520.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#287c89",
    d: "M3777,1750.41c-16.19,34.31-21.21,60-26.52,87.17-5.23,26.71-10.63,54.34-27.49,92.44-31.15,70.39-72.89,112.55-113.27,153.32-8.55,8.64-17,17.16-25.19,25.83-87.67,92.55-162.57,217.17-222.36,369.83-.42.78-42.44,78.69-56.69,153.36l7,.39c14-73.15,55.25-149.74,55.93-151.07,59.57-152,133.78-275.55,220.57-367.18,8.16-8.6,16.55-17.08,25.05-25.66,41-41.41,83.4-84.22,115.3-156.3,17.31-39.12,22.82-67.29,28.14-94.54,5.19-26.57,10.1-51.66,25.76-84.86,30.8-65.29,86-123.43,164.13-172.8l-2.73-6.79C3865,1623.89,3808.59,1683.39,3777,1750.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#115b5b",
    d: "M3445.91,2402.69l-123.38,174.69s321.13-245.7,560.63-375.34l-206.75,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#318971",
    d: "M3771.52,2071.66c-36.74,33.72-46.88,64.68-119,136.52-80.85,80.58-115.3,88.68-176,147.48-42,40.66-99.37,108.29-154,221.72,0,0,55.37-79.86,170.5-198.17s218.09-131.7,321.67-149.94,201.78-151.79,234-167.68,60.5-5.74,60.5-5.74C3927.76,1981,3828.86,2019,3771.52,2071.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#115b5b",
    d: "M3812.8,2135.43c-42.8,34.76-89.17,64.89-138.27,96.8-125.62,81.64-255.52,166.06-355,343.47l-32.45,57.89,6,3.36,32.45-57.89c98.27-175.29,227.18-259.07,351.86-340.09,49.3-32,95.86-62.3,139-97.35,146.94-119.33,227.53-91.21,228.33-90.91l3.28-7.62C4044.63,2041.8,3963.49,2013.06,3812.8,2135.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112e41",
    d: "M1146.32,2062.69c.76,3.7,78.46,372.85,292.44,621.49l4.94-5.25c-212.23-246.58-289.42-613.19-290.18-616.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#318971",
    d: "M1036.49,1541.3s-22.93,287.63,120.36,529.49c0,0-3.08-231.28-57.62-390.64A819,819,0,0,0,1036.49,1541.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47b971",
    d: "M1086,1789.76c-3.67,137.44-27.41,238,136.76,436.65,0,0-68.14-510.52-186.24-685.11C1036.49,1541.3,1089.64,1652.32,1086,1789.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70d271",
    d: "M1087.48,2019.72c-61.51-130.84-32-154.67-85.38-246.94C901,1598.1,705.61,1528.94,699.55,1549.08c-3.63,12,63.18,46.08,106.61,136.62,49.8,103.81,6.78,152.43,37.73,254.55,35.48,117.11,115.09,129.21,265,313.27,148.26,182,223.62,321.86,223.62,321.86,21.51-7.34-3-141.71-59.74-264.11C1208,2171.29,1155.09,2163.53,1087.48,2019.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47b971",
    d: "M886.27,2022c218.39,332.44,446.28,553.35,446.28,553.35C1164.14,2221.32,886.27,2022,886.27,2022Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#287c4b",
    d: "M1111.21,2142.08c-8.1-9.28-16.46-18.43-24.92-27.7-40-43.77-81.28-89-110.39-162.88-15.75-40-20.12-68.65-24.34-96.39-4.29-28.22-8.35-54.87-23.58-90.92-29.74-70.4-85.46-134.16-165.61-189.53l-3.14,6.87c78.62,54.3,133.17,116.61,162.15,185.2,14.72,34.87,18.69,60.92,22.89,88.5,4.3,28.29,8.75,57.54,24.93,98.58,29.81,75.62,71.77,121.59,112.35,166,8.41,9.22,16.72,18.32,24.78,27.54,85.72,98.19,157,228.66,211.92,387.81.64,1.4,40,82.08,51.17,158l7.3-.08c-11.44-77.51-51.46-159.59-51.86-160.41C1269.77,2372.89,1197.8,2241.27,1111.21,2142.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#115b5b",
    d: "M1011.29,2250.67l-213.14-26.25c242,144.11,563.34,411.33,563.34,411.33l-119.91-185.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#318971",
    d: "M1036.43,2241c-71.39-77.17-80.51-109.5-117-145.85-57-56.73-157.61-100.26-348.64-31.28,0,0,29.67-9.2,62.33,8.6s128.34,159.65,234.67,183,212.26,41.74,326.11,168.66,167.61,211.59,167.61,211.59c-51.5-119.2-107.86-191.38-149.5-235.1C1151.78,2337.41,1116.51,2327.55,1036.43,2241Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11624f",
    d: "M1012.63,2264.77c-49.38-35-96-68.11-138.75-105.79-150.46-132.68-235.66-106.7-239.21-105.53l3.06,8c.84-.27,85.45-25.63,232.17,103.74,43.1,38,89.93,71.23,139.5,106.4,125.39,89,255,180.94,348.94,365.77l31,61,6.29-3.2-31-61C1269.61,2447.09,1139,2354.41,1012.63,2264.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52261f",
    d: "M3316.16,1068.36c-9.17-32.69-27-49-51.37-61.44-23.4-12-124.41,34.1-124.41,34.1s-3.44,64.65-45.43,103.1c-1.44,1.32-3,2.41-4.47,3.66-18.62,16.26-26.49,36.91-19.32,55.74,4.05,10.64,12.43,19.28,23.4,25.57,23.68,17.52,75.63,29.48,134.72,29.48q15.64,0,31.27-1.14c29.31-2.16,59.91-6.85,86.69-18.78,23.07-10.27,43.48-30.44,35.74-56.5C3372.79,1147.84,3337.34,1143.83,3316.16,1068.36Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3101.21,
    cy: 2538.85,
    fill: "#7e7eef",
    rx: 704.18,
    ry: 133.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1925.95,
    cy: 2628.17,
    fill: "#7e7eef",
    rx: 864.93,
    ry: 131.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 170.89,
    height: 1048.25,
    x: 1416.18,
    y: 1481.07,
    fill: "#f3fcff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 236.2,
    height: 151.3,
    x: 1383.52,
    y: 1420.11,
    fill: "#ffcb83",
    rx: 21.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1407.28,
    y: 1420.11,
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1461.12,
    y: 1420.11,
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1514.97,
    y: 1420.11,
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1568.81,
    y: 1420.11,
    fill: "#e6a748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d4902b",
    d: "M1434.43,1586.72a32.31,32.31,0,0,0,32.31,32.31h69.76a32.3,32.3,0,0,0,32.31-32.3v-15.86H1434.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e74a60",
    points: "1434.08 1972.54 1434.08 2529.32 1569.16 2529.32 1569.16 1972.54 1491.61 1993.76 1434.08 1972.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b20b1f",
    d: "M1527.67,1970c-34.83,20.14-93.59,2.59-93.59,2.59s82.42,57.14,118.9,27.21C1588.42,1970.67,1562.51,1949.81,1527.67,1970Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.7,
    height: 920.21,
    x: 1447.78,
    y: 1594.95,
    fill: "#fff",
    opacity: 0.2,
    rx: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    width: 170.89,
    height: 1048.25,
    x: 1711.49,
    y: 1481.07,
    fill: "#f3fcff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 236.2,
    height: 151.3,
    x: 1678.83,
    y: 1420.11,
    fill: "#ffb633",
    rx: 21.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1702.59,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1756.44,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1810.28,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1864.13,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M1729.74,1586.72a32.31,32.31,0,0,0,32.32,32.31h69.76a32.31,32.31,0,0,0,32.31-32.3v-15.86H1729.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e74a60",
    points: "1729.4 1972.54 1729.4 2529.32 1864.47 2529.32 1864.47 1972.54 1786.92 1993.76 1729.4 1972.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b20b1f",
    d: "M1823,1970c-34.84,20.14-93.59,2.59-93.59,2.59s82.42,57.14,118.9,27.21C1883.73,1970.67,1857.82,1949.81,1823,1970Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.7,
    height: 920.21,
    x: 1743.09,
    y: 1594.95,
    fill: "#fff",
    opacity: 0.2,
    rx: 10.69
  }), /*#__PURE__*/React.createElement("rect", {
    width: 170.89,
    height: 1048.25,
    x: 2006.81,
    y: 1481.07,
    fill: "#f3fcff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 236.2,
    height: 151.3,
    x: 1974.15,
    y: 1420.11,
    fill: "#ffb633",
    rx: 21.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 1997.91,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 2051.75,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 2105.6,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.15,
    height: 150.76,
    x: 2159.44,
    y: 1420.11,
    fill: "#f46d00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M2025.06,1586.72a32.3,32.3,0,0,0,32.31,32.31h69.76a32.31,32.31,0,0,0,32.31-32.3v-15.86H2025.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e74a60",
    points: "2024.71 1972.54 2024.71 2529.32 2159.79 2529.32 2159.79 1972.54 2082.23 1993.76 2024.71 1972.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b20b1f",
    d: "M2118.3,1970c-34.83,20.14-93.59,2.59-93.59,2.59s82.42,57.14,118.9,27.21C2179,1970.67,2153.13,1949.81,2118.3,1970Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2049.09,1595h5.32a10.69,10.69,0,0,1,10.69,10.69v898.84a10.69,10.69,0,0,1-10.69,10.69h-5.33a10.68,10.68,0,0,1-10.68-10.68V1605.64A10.69,10.69,0,0,1,2049.09,1595Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#064a85",
    d: "M2415.76,1714.56H1178.11a26.94,26.94,0,0,0-26.94,26.94v68.57a26.94,26.94,0,0,0,26.94,26.94h90.62v678.15H1171a19.87,19.87,0,0,0-19.86,19.87v35.38a19.86,19.86,0,0,0,19.86,19.86H2422.84a19.86,19.86,0,0,0,19.86-19.86V2535a19.87,19.87,0,0,0-19.86-19.87h-97.7V1837h90.62a26.94,26.94,0,0,0,26.94-26.94V1741.5A26.94,26.94,0,0,0,2415.76,1714.56Zm-138,800.6H1316.08V1837h961.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d3d3d",
    d: "M3046.33,2385.15c-144,0-269.33,8.83-311.55,44.13-10.26,8.58-12.56,34.42-12.56,43.92,0,48.63,145.11,88.05,324.11,88.05s324.11-39.42,324.11-88.05c0-6.08-3.22-27.93-7.54-33.66C3332.68,2399.42,3203,2385.15,3046.33,2385.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3046.33,
    cy: 2445.29,
    fill: "#6e6e6e",
    rx: 317.31,
    ry: 86.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d3d3d",
    d: "M2962.9,2202.39l-8.79,201.85c0,13.38,41.28,24.22,92.22,24.22s92.22-10.84,92.22-24.22l-8.79-201.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3046.33,
    cy: 2202.39,
    fill: "#6e6e6e",
    rx: 83.43,
    ry: 18.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d3d3d",
    d: "M2993.68,2191v11.75c9.63,4.36,29.55,7.36,52.65,7.36s43-3,52.64-7.36V1993.36H2993.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d4a9b",
    d: "M3476.33,1326.61c-49.45-35.37-117.8-45-117.8-45s-184.39,345.35-220.43,405S3031.2,1838,2949.67,1867.17s-373.84,189.08-412.67,229.2-208.22,169-208.22,169,1.34,73.07,51.67,105.47c40.18,25.85,119,50.54,241.22-23.5,123.24-74.65,165.27-161.15,247.6-226.54s197.51-45.7,247.57-40.71,121,19.86,177.95-42.91,134.48-289.87,154.72-336,81.74-187.69,87.51-240.8S3525.77,1362,3476.33,1326.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d71d4",
    d: "M3428.54,1325.45c-62.42-35.44-114.7-24.11-114.7-24.11s-164.23,345.3-214.39,419.56-161.87,63.9-237.29,61.53-219.31,98-260.83,125.7-200.08,144-235.8,188c-28.43,35-51,123.42-35.33,189.16s61,81.84,159.05,69.22,206-99.41,258.39-156.86,101.45-130,181.31-160.3,206.14,27.32,298.26-12.82,132.34-200.11,157.37-257.39,110.85-266,114.28-310S3491,1360.89,3428.54,1325.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d51870",
    d: "M2491.55,1797a43.82,43.82,0,0,0-35.35,27.43L2220,2416.32h116.77l276.13-470.46h504.85l30.39-154.59-281.21-40.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004f73",
    d: "M2370,2360.27h-.05l-123.06-10.85a.5.5,0,0,1-.46-.54.5.5,0,0,1,.55-.45L2370,2359.27a.5.5,0,0,1,.45.55A.49.49,0,0,1,2370,2360.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02334a",
    d: "M2223.65,2373.23c-41.6,6.1-81.71,27.7-105.67,62.26l220.37,25.92a150.72,150.72,0,0,0,8.42-69.32C2308.12,2375.54,2265.25,2367.13,2223.65,2373.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2255.52,2402.66a2.46,2.46,0,0,1-2-1,63.12,63.12,0,0,0-44.45-25.82,2.5,2.5,0,0,1,.51-5,68.18,68.18,0,0,1,48,27.89,2.5,2.5,0,0,1-2,3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2224.62,2405.14a2.54,2.54,0,0,1-1.84-.81,64.51,64.51,0,0,0-48.22-20.5,2.5,2.5,0,1,1-.12-5,69.55,69.55,0,0,1,52,22.11,2.51,2.51,0,0,1-1.84,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2203.32,2412.78a2.49,2.49,0,0,1-1.77-.73,56.62,56.62,0,0,0-46.84-15.81,2.5,2.5,0,0,1-.67-5,61.72,61.72,0,0,1,51.05,17.24,2.5,2.5,0,0,1-1.77,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1870",
    d: "M3198,1808.44l-169.55-58-447.48,67.11a64.49,64.49,0,0,0-52.31,47.4l-128.24,537.2,120.29,14.21,194-448,453.94-2.21a35.4,35.4,0,0,0,35.15-37.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004f73",
    d: "M2533.8,2386.49h-.11l-123.32-26.22a.5.5,0,1,1,.21-1l123.32,26.22a.51.51,0,0,1,.39.59A.5.5,0,0,1,2533.8,2386.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b60b55",
    d: "M2439.4,2245a3.54,3.54,0,0,1-.85-.11,3.49,3.49,0,0,1-2.55-4.24l94.49-380.26a60.26,60.26,0,0,1,49.55-45l329.35-49.85a3.5,3.5,0,1,1,1.05,6.92l-329.35,49.85a53.25,53.25,0,0,0-43.8,39.83l-94.5,380.25A3.51,3.51,0,0,1,2439.4,2245Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b60b55",
    d: "M2715.37,1971.88a3.49,3.49,0,0,1-3.36-2.53,126.48,126.48,0,0,0-40.24-61.48,3.5,3.5,0,1,1,4.47-5.38,133.47,133.47,0,0,1,42.49,64.92,3.49,3.49,0,0,1-2.39,4.33A3.25,3.25,0,0,1,2715.37,1971.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02334a",
    d: "M2400.33,2397.88c-41.18,8.51-80,32.4-101.88,68.29L2520,2479.25a150.64,150.64,0,0,0,4.37-69.69C2484.78,2395.28,2441.51,2389.37,2400.33,2397.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2427.79,2427.51a2.51,2.51,0,0,1-2.15-1.22,56.72,56.72,0,0,0-44.92-26.91,2.5,2.5,0,0,1,.24-5,61,61,0,0,1,49,29.34,2.51,2.51,0,0,1-2.15,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2409.35,2437.73a2.49,2.49,0,0,1-1.94-.92,71.89,71.89,0,0,0-48.73-25.86,2.5,2.5,0,0,1,.43-5,77,77,0,0,1,52.18,27.69,2.51,2.51,0,0,1-.36,3.52A2.53,2.53,0,0,1,2409.35,2437.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2387.08,2446.54a2.49,2.49,0,0,1-2.1-1.14,59.09,59.09,0,0,0-41.88-26.06,2.5,2.5,0,0,1,.6-5,64.15,64.15,0,0,1,45.47,28.3,2.51,2.51,0,0,1-2.09,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3069.34,1313.86c-29.54,14.24-54.87,36.11-76.6,60.66-18.88,21.32-33.74,45.18-50.87,67.78-5.9,7.78-14.43,12.48-20.42,20.2-4.24,5.47-8.11,11.22-12.35,16.69-2.35,3-6.19,10-9.73,11.68-79.1,36.65-187.21,49.22-267.76,60.67,0,5.76,3.41,72.88,5.27,72.88,98.59,2.62,281.6,10.46,350.38-50.1,59.85-52.7,161.19-176.5,110.29-256.86C3088.23,1310.63,3080,1308.73,3069.34,1313.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2909.87,1478.19c17.45,38.12,39.15,75.22,43.5,117.22,15.34-7,31.87-17.56,43.87-29.42C2995.34,1508.64,2965.62,1483.94,2909.87,1478.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f46d00",
    points: "2967.18 1500.69 2923.73 1454.06 2908.64 1476.62 2987.32 1577.03 2998.84 1566.64 2994.47 1555.82 2967.18 1500.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb633",
    d: "M2971.25,1391.22a27.1,27.1,0,0,0-28.73,37.59,23.52,23.52,0,0,0-24.86,12c-4.27,8.3-2.53,16.36,1.88,24,7.08,12.19,21.05,23.18,28.24,32a315.76,315.76,0,0,1,40.11,63.54c2.41,5.07,3.08,6.84,8.85,7.75,6.2,1,12.54-.78,18.45-2.47,2.63-.75,5.36-1.56,7.38-3.4,2.73-2.51,3.63-6.53,3.22-10.22s-2-7.12-3.5-10.5c12.9-1.3,23.18-11.08,31.68-20.87a285.7,285.7,0,0,0,21.73-28.47c3.19-4.76,6.9-9.7,9.22-15,1.59-3.61,1.55-7.52,2.7-11.26,3.69-12,8.61-23.43,11.7-35.66a263.89,263.89,0,0,0,6.48-36.07c1.65-15.17.45-30.09,1.11-45.22.78-18.1-6-37.72-9.63-55.55C3051.39,1320.88,3004.44,1349.27,2971.25,1391.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3006.62,1533.38a3,3,0,0,1-2.69-1.66c-17.39-34.77-35.36-70.73-64.54-98.51a3,3,0,1,1,4.13-4.35c29.94,28.51,48.16,64.94,65.78,100.17a3,3,0,0,1-2.68,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3017.81,1442.67a3,3,0,0,1-2.59-1.48c-10-16.93-24-33.07-42.89-49.34a3,3,0,0,1,3.91-4.55c19.41,16.71,33.85,33.34,44.15,50.85a3,3,0,0,1-2.58,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M2688,1539.44a59.39,59.39,0,0,0-10.26-6.29c-2.75-1.44-5.51-2.86-8.09-4.55a45.17,45.17,0,0,1-13-13c-1.58-2.39-2.9-4.85-4.54-7.18a47.78,47.78,0,0,1-4.34-7.45c-1-2.12-1.9-4.48-3.91-5.68a7.34,7.34,0,0,0-6-.29c-5.34,1.76-8.94,7.2-9.57,12.79s1.31,11.22,4.29,16,7,8.82,10.84,12.89a87.4,87.4,0,0,1,7.68,8.86,49.88,49.88,0,0,1,4.61,8.18,42.2,42.2,0,0,0,37.41,24,5,5,0,0,0,3.4-.83,4.89,4.89,0,0,0,1.23-2.08,31.44,31.44,0,0,0-9.73-35.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M2637,1546.58c-3.95-1.85-7.56-4.77-9.4-8.73-2.5-5.37-1.61-12.22-5.43-16.75-4-4.73-11.68-4.65-17-1.5a28,28,0,0,0-12,15.36c-2.23,6.8-5.58,12.71-6.72,19.94-.88,5.61-1.06,11.67-4.37,16.29-1.81,2.53-4.43,4.39-6.24,6.92-3.26,4.54-3.52,10.64-2.32,16.09,3.23,14.7,16.1,26,30.5,30.36a64.88,64.88,0,0,0,23.73,2.29c5.58-.42,11.39-2.26,16.84-2.33s9.74-1.58,13.06-6.43c2.91-4.25,4.1-9.42,5.29-14.44q5.76-24.14,13.56-47.73l-27-5.67A56.55,56.55,0,0,1,2637,1546.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2685.83,1596.06a49.52,49.52,0,0,1-45.27-29.25,2.5,2.5,0,0,1,4.56-2,44.52,44.52,0,0,0,43.6,26.2,2.5,2.5,0,1,1,.34,5C2688,1596,2686.91,1596.06,2685.83,1596.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#064a85",
    d: "M2653.58,1527.4a47.31,47.31,0,1,0,6.56,66.59A47.31,47.31,0,0,0,2653.58,1527.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M2637.93,1536.18c2.71,0,4.29-3.22,4.6-5.43a9.54,9.54,0,0,0-2.17-7.6c-2-2.2-4.81-3.34-7.61-4.25a80.51,80.51,0,0,0-25.67-4c-6.22,0-12.61.89-18,4s-9.24,7.91-12,13.3a65.5,65.5,0,0,0-4.56,11.51c-4.63,15.9-3.65,33.56.8,49.24,1.52,5.39,3.78,12.29,8.73,15.54,5.18,3.39,10.55-.51,14.09-4.41-3.92-14.81,18.84-13,27.67-9.57,8.91,3.89,16.12-9.14,8.7-15.11,12.39,4.09,19.42-14.54,7.43-19.66C2659.68,1561.71,2653.65,1536.14,2637.93,1536.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2574.1,1591a2.49,2.49,0,0,1-1.84-4.19,51.67,51.67,0,0,1,60.55-11.43,2.5,2.5,0,0,1-2.18,4.5,46.65,46.65,0,0,0-54.69,10.32A2.53,2.53,0,0,1,2574.1,1591Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2573.37,1546.3a2.5,2.5,0,0,1-1.6-4.42c8.14-6.77,19.14-11,31-12,10.05-.8,21.05.66,32.68,4.33a2.5,2.5,0,0,1-1.51,4.77c-11-3.48-21.37-4.86-30.77-4.11-10.82.86-20.83,4.7-28.19,10.81A2.46,2.46,0,0,1,2573.37,1546.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2572.74,1565.54a2.5,2.5,0,0,1-1.4-4.57,68.34,68.34,0,0,1,68.62-4.56,2.5,2.5,0,1,1-2.22,4.48,63.38,63.38,0,0,0-63.61,4.22A2.47,2.47,0,0,1,2572.74,1565.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7183c",
    d: "M2633,1740.77c-35.21,0-71.42-7.15-102.32-20.5-14.16-6.11-51.78-22.36-83-59.36-42-49.73-44.11-102.86-49.17-231.2-.55-14-1.12-28.57-1.79-44.25-2.85-66.79-6.69-135.45-11.42-204.08a1,1,0,0,1,2-.13c4.72,68.64,8.56,137.32,11.42,204.12.67,15.69,1.24,30.21,1.79,44.26,5,127.86,7.12,180.78,48.69,230,31,36.65,68.27,52.76,82.31,58.83,37.76,16.3,83.52,23.29,125.56,19.18,47-4.6,86.4-22,114-50.32,20.7-21.25,36.9-46.9,52.57-71.71l4.87-7.7c22.09-34.8,41.16-64.85,85.13-75a1,1,0,1,1,.45,1.94c-43.17,10-62,39.74-83.89,74.16l-4.87,7.7c-15.72,24.89-32,50.64-52.83,72-27.91,28.66-67.76,46.26-115.22,50.91C2649.24,1740.39,2641.13,1740.77,2633,1740.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2911.32,1528.4c-6-.76-12.81.92-18.38,2.73a56.11,56.11,0,0,0-16.7,8.7,1.2,1.2,0,0,0-.4,2l8.64,14.53a2,2,0,0,0,1.07,1,2.1,2.1,0,0,0,1.23-.17,304.66,304.66,0,0,0,29.7-12.45c2.17-1,4.43-2.21,5.65-4.23,1.66-2.77.75-6.57-1.66-8.81S2914.46,1528.8,2911.32,1528.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb633",
    d: "M3137.5,1275.38c-104.44,25.53-132.27,160.74-95.22,249.91,3.89,11.17,8.23,22.2,12.86,33,.12.29-54.84,37.36-59.77,41.11-60,44.6-109.31,101.19-159.07,156.42,20-7.4,62.71-4.78,73.61,13.06,124.63-2.62,224.91,94.32,288.42,190.6,95-70.75,94.3-209.3,112.85-315.55,58.16-71.79,111-153.27,108.53-250.08C3416.36,1252.21,3241.08,1246.89,3137.5,1275.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3192.23,1264.46c-20-.8-41.75,9.59-43.42,31.64-1.92,52,120.42,14.61,134.69-14.2C3286.7,1246.23,3214.76,1265.3,3192.23,1264.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3123.39,1819.61a3,3,0,0,1-1.91-.7,323.62,323.62,0,0,0-205.68-74.13,3,3,0,0,1-3-3,3,3,0,0,1,3-3,329.5,329.5,0,0,1,209.53,75.52,3,3,0,0,1-1.92,5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8b041d",
    d: "M2964.32,1732.17a173,173,0,0,1-55.42-9.1.5.5,0,1,1,.32-1,172,172,0,0,0,76.92,7.65.5.5,0,0,1,.56.43.51.51,0,0,1-.43.56A171.27,171.27,0,0,1,2964.32,1732.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3043.81,1533.52a3,3,0,0,1-2.91-2.29c-7-28.69-13.88-59.35-15.17-90.94-1.42-34.71,4.37-65.21,17.2-90.66a3,3,0,1,1,5.36,2.7c-12.37,24.53-17.94,54-16.57,87.71,1.27,31,8.11,61.37,15,89.77a3,3,0,0,1-2.21,3.62A2.88,2.88,0,0,1,3043.81,1533.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3266.89,1167.16c-10.44-27.38-43.36-22.85-58.09-1.78-26.68,37.55-25.58,88.61-42,131,33.47,18.14,74.09-8.13,101.94-27.76-.84-4.08-1.51-8.18-2-12.3C3262,1227,3267.52,1196.39,3266.89,1167.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3027.76,1617.5c1.22,21.46,6.8,43.8,10,65.17,81.87-2.19,163.66-6,245.49-9.94q-30.87-52-66-101.32A1660.47,1660.47,0,0,0,3027.76,1617.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ee6a4a",
    points: "3246.76 1674.49 3289.12 1672.73 3217.3 1571.41 3246.76 1674.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3234.14,1568.47c-5.62,1-11.23,1.92-16.84,2.94,23.4,32.84,45.42,68.4,66,103.08,12-.58,24-2.93,35.95-3.51-12.73-17.28-25.78-34.33-39.31-51C3265.45,1602.15,3250.43,1584.65,3234.14,1568.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb633",
    d: "M3393.85,1318.7c-92.54-14.33-85.6,179.18-75.36,237.41-28.22,3.36-56.34,7.54-84.35,12.36,16.29,16.18,31.31,33.68,45.8,51.52,13.53,16.66,26.58,33.71,39.31,51q25.44-1.24,50.9-2.49c50.3-2.43,85.24-25.42,79.39-75.19C3445.53,1529.26,3454.05,1350.46,3393.85,1318.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3217.3,1574.41a3,3,0,0,1-.44-6L3315,1553.6a400.57,400.57,0,0,1,18-207.83,3,3,0,1,1,5.64,2,394.86,394.86,0,0,0-17.15,207.76l.56,3-104.25,15.76A2.28,2.28,0,0,1,3217.3,1574.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46d00",
    d: "M3356.33,1590.25a3,3,0,0,1-2.49-1.33,85.75,85.75,0,0,0-35.78-30,3,3,0,1,1,2.43-5.48,91.75,91.75,0,0,1,38.33,32.13,3,3,0,0,1-2.49,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M2907.24,1661.48c-.64-.06-1.29-.08-1.94-.08A5.05,5.05,0,0,0,2907.24,1661.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3031,1616.73a109,109,0,0,0-62.24-6.69c-8.91,1.67-17.56,4.46-26.18,7.24-3.53,1.14-7.65,2.94-8.19,6.6-.42,2.83,1.71,5.54,4.3,6.74s5.56,1.23,8.42,1.24l-32.39,10.1c-3.38,1-6.83,2.14-9.68,4.24s-5,5.45-4.81,9a7,7,0,0,0,5.08,6.22c.65,0,1.3,0,1.94.08a5.05,5.05,0,0,1-1.94-.08,15.17,15.17,0,0,0-9.75,3.29c-3.16,2.69-4.78,7.35-3.26,11.21s6.53,6.16,10.2,4.21c-4.1,1.6-5.58,7.22-3.66,11.19s6.31,6.26,10.68,6.84,8.79-.31,13.11-1.18c-5.83,1.18-3.68,9.31.21,11.43,3.05,1.65,6.72,1.48,10.18,1.22a340.21,340.21,0,0,0,113.32-28.84l-1.81,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02334a",
    d: "M2922,1697.49a.5.5,0,0,1-.1-1l59.07-12.25a.51.51,0,0,1,.59.39.49.49,0,0,1-.39.59l-59.07,12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2902.36,1682.94a2.51,2.51,0,0,1-.7-4.91,319.65,319.65,0,0,1,58.89-11.29,2.5,2.5,0,1,1,.48,5,314,314,0,0,0-58,11.12A2.82,2.82,0,0,1,2902.36,1682.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2905.43,1664a2.5,2.5,0,0,1-.75-4.89,437.4,437.4,0,0,1,51.41-12.83,2.5,2.5,0,0,1,.91,4.92,431.15,431.15,0,0,0-50.81,12.68A2.51,2.51,0,0,1,2905.43,1664Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M2948,1634.16a2.5,2.5,0,0,1-1-4.8,113.28,113.28,0,0,1,33.16-8.6,2.5,2.5,0,0,1,.51,5,108.44,108.44,0,0,0-31.7,8.22A2.48,2.48,0,0,1,2948,1634.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b04521",
    d: "M1863.47,2544c-17.52-4.51-36.3-1.54-53.84-6-26-6.6-40.64-27-48.48-51.16l-102.59,5.64a246.35,246.35,0,0,0-21.06,108.95l276.94,3.11c-4.33-13.46-7.64-26.88-16.72-38.13A65.55,65.55,0,0,0,1863.47,2544Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1760.42,2551.45a2.4,2.4,0,0,1-1.07-.25,2.49,2.49,0,0,1-1.18-3.33,45.27,45.27,0,0,1,38.69-25.18,2.5,2.5,0,0,1,.15,5,40.17,40.17,0,0,0-34.33,22.33A2.5,2.5,0,0,1,1760.42,2551.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1786,2563.75a2.5,2.5,0,0,1-2.09-3.86,75.22,75.22,0,0,1,31-27,2.5,2.5,0,1,1,2.11,4.53,70.35,70.35,0,0,0-28.89,25.16A2.52,2.52,0,0,1,1786,2563.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1816.43,2573.55a2.56,2.56,0,0,1-1-.22,2.5,2.5,0,0,1-1.23-3.32,66.19,66.19,0,0,1,32.55-32.37,2.5,2.5,0,0,1,2.06,4.56,61.15,61.15,0,0,0-30.07,29.89A2.5,2.5,0,0,1,1816.43,2573.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#02334a",
    points: "1412.45 1432.33 1640.66 2514.18 1792.66 2514.18 1672.77 1432.33 1412.45 1432.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b04521",
    d: "M1511.41,2544c-17.52-4.51-36.3-1.54-53.84-6-26-6.6-40.64-27-48.49-51.16l-102.59,5.64a246.48,246.48,0,0,0-21,108.95l276.93,3.11c-4.33-13.46-7.63-26.88-16.72-38.13A65.48,65.48,0,0,0,1511.41,2544Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1483.09,2567.53a2.47,2.47,0,0,1-.92-.18,2.51,2.51,0,0,1-1.41-3.24,39.91,39.91,0,0,1,35.29-24.63,2.5,2.5,0,0,1,.12,5,34.79,34.79,0,0,0-30.76,21.46A2.49,2.49,0,0,1,1483.09,2567.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1447.93,2562.14a2.55,2.55,0,0,1-1-.22,2.5,2.5,0,0,1-1.24-3.31c3-6.73,8.78-12.76,16.55-17.43,6.78-4.08,14.24-6.72,21.45-9.27a2.5,2.5,0,1,1,1.66,4.71c-7,2.47-14.18,5-20.53,8.84-6.9,4.15-11.94,9.41-14.58,15.21A2.5,2.5,0,0,1,1447.93,2562.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1421,2551.79a2.54,2.54,0,0,1-1.53-.53,2.5,2.5,0,0,1-.44-3.51,53.2,53.2,0,0,1,37.33-20.1,2.5,2.5,0,0,1,.38,5,48.09,48.09,0,0,0-33.76,18.18A2.51,2.51,0,0,1,1421,2551.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#02334a",
    points: "1285.27 2514.18 1451.06 2514.18 1538.25 1442.21 1300.25 1432.33 1285.27 2514.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004f73",
    d: "M1501.6,1855.44h0a.5.5,0,0,1-.45-.54l21.1-232.53a.5.5,0,0,1,.5-.45h32.86a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-32.41L1502.09,1855A.49.49,0,0,1,1501.6,1855.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M2020.53,1114.48a419.26,419.26,0,0,0,45.29,36.54c13.79-13.25,29.22-26.66,39.35-43.06V997.19l-56.2,65C2035.79,1077.1,2028.56,1096.45,2020.53,1114.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M2054.59,1072.63c-1.62-3.06-3.16-6.26-3.51-9.71a25.63,25.63,0,0,1,.77-8c1.27-5.82,3.09-11.54,3.69-17.47s-.17-12.25-3.63-17.1a8.38,8.38,0,0,0-3.52-3.08,4.24,4.24,0,0,0-4.44.58c-2.21,2-2.56,6.82-3.68,9.58a107.31,107.31,0,0,1-5.14,10.57c-3.73,6.9-7.8,13.73-10,21.31-3.65,12.41-2,25.73-4,38.52-.56,3.67-1.41,7.44-.49,11,1.07,4.17,4.2,7.36,8.06,9.54a28.37,28.37,0,0,0,13.15,3.56c3.38,0,5.32-1.26,8.12-3.13,5.48-3.65,10.86-8.22,13-14.69,1.74-5.33,1-11.2-.92-16.47S2057.2,1077.58,2054.59,1072.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1998.9,1096.68c-21.05,15.57-179.51,117.21-198.76,149.69-12.23-89.5-49-185.09-120.8-243.2l-61.86,233.53c44.91,71.07,129.65,319.29,240.63,178,46-58.57,207-184.32,216.47-257.31C2051.92,1133.36,2025.67,1116.54,1998.9,1096.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6c8e8",
    d: "M1760.3,1339l-5.63-2.09a658.67,658.67,0,0,1,42.2-91.3l5.23,2.92A652.88,652.88,0,0,0,1760.3,1339Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d71d4",
    d: "M1424.29,951.86c-54.15,16.11-173.83,28.23-172.6,100.55-8.48,156.06,22.62,311.74,35,467.06l399,10.2c11.6-167.78,38.71-342.47,12.45-508.14C1618.27,974.08,1518.44,944.19,1424.29,951.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#064c91",
    d: "M1373.2,1312.35c60.16,48.47,143,80,220.37,70.78,13.41-4.07,13.29-35.49,16.32-43.91C1530.3,1353.67,1449.91,1332.82,1373.2,1312.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#064c91",
    d: "M1491.9,931.55c-101.73-24.24-48.32,94.89,7.78,115.31,18.81,7,34-34.06,40-48.16C1553.56,961.34,1525.85,938.77,1491.9,931.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#064c91",
    d: "M1628,1416.66c-45.29-1.32-89.35,9.78-135.37,8.71-40.82,1.11-81.83.46-122.73-.19,10.53,5.8,27.1,10.14,45.66,12-121.82,23.72,206.2,20.16,227.36,30.51-13-12.07-33.36-23.09-59.21-32.05C1604.33,1432.89,1626.64,1425,1628,1416.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1434.5,939.84c-68.18,19.8-167.57,20.58-195,97.19,3.69,271.21,23.86,543.84,12.58,816.37,30.15-1.72,58.51,23.28,87.83,31,9.26,3.82,98.29,35.31,97.91,40.38C1475.71,1597,1414.22,1266,1434.5,939.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M1344.87,1439.53c-2-4.32-4-8.63-6.4-12.78-6.43-11.35-15.46-19.63-29.25-18.41-9.94.88-19.14,6.36-26.23,13.15-6,5.75-12.09,13.66-13.09,22.21-.36,3.1.06,6.36,2.09,8.85,1.6,2,5.09,3,7.3,4,3.25,1.58,3.4,2.55,3.59,6.1a206.54,206.54,0,0,0,3.84,29.63l67.07,4.1,4,.25a12.77,12.77,0,0,0,5.16-.38,4.41,4.41,0,0,0,3.12-3.78,6.46,6.46,0,0,0-.5-2.2Q1356.4,1464.46,1344.87,1439.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M1284.86,1433.45a145.87,145.87,0,0,0,0,44.15,96.83,96.83,0,0,0,49.28-57.07c-7.6-6.27-15.51-12.36-24.3-16.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dcf2ff",
    points: "1283.07 1598.87 1342.66 1619.47 1395.77 1600.47 1395.77 1486.2 1277.44 1486.2 1283.07 1598.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1715.79,1092.57c19.69-116.73-121.56-111-193.09-154.48,49.44,313.06,65.16,630.16,88.3,945.93q1.49,21.23,3,42.46c36.55-20.81,98-39.23,130-64.07C1726,1606.33,1711.62,1349.52,1715.79,1092.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6c8e8",
    d: "M1716.85,1407.27c-2.43-101-13.65-212.9-35.26-351.67l-.78,0-.17-6.24,6-.54c22.25,141.75,33.76,255.6,36.24,358.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dcf2ff",
    points: "1660.26 1482.65 1660.26 1595.05 1716.99 1626.63 1728.49 1617.8 1723.41 1482.65 1660.26 1482.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1208.44,1278.62c58-71.2,143.24-149.77,126.42-250.92-5.14-21.28-20.95-51.15-45.94-46-36.08,18.51-66.72,58.9-94.56,88.1-31.39,32.93-61.35,67.36-87.66,104.53-.17.24-.33.48-.5.71-19.67,27.86-37.82,59.16-37.89,93.26,0,23.84,8.91,47,21.6,67.17,18.93,30.09,44.56,60.1,69.73,85,7.17,7.08,85.54,80.15,89.49,76a853.89,853.89,0,0,1,89.15-80.23C1288.7,1375.09,1247.4,1329,1208.44,1278.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6c8e8",
    d: "M1249.65,1240.77l-4.29-4.2c39.14-39.91,73.36-98,89.29-151.58l5.75,1.71C1324.21,1141.17,1289.43,1200.2,1249.65,1240.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 44.66,
    x: 1181.63,
    y: 1252.66,
    fill: "#a6c8e8",
    transform: "rotate(-82.06 1184.623 1274.997)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6c8e8",
    d: "M1334.46,1421.59,1319.2,1406c-27.28-27.86-47-48-74.56-78.45l4.45-4c27.48,30.36,47.16,50.46,74.4,78.27l15.26,15.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 41.91,
    height: 6,
    x: 1246.94,
    y: 1477.67,
    fill: "#a6c8e8",
    transform: "rotate(-47.7 1267.823 1480.633)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6c8e8",
    d: "M1564.65,1038.67c12.19-11.18,43.87-13.4,34.89-36.78a186.62,186.62,0,0,0-75.33-89.58c2.67,113.91,29,225.32,38.77,338l41.16-206.38A93.7,93.7,0,0,1,1564.65,1038.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M1527,882.28c-26.74-9.93-67.8-24.26-90.67-39.86-2.14,16.54,2.43,12.13.29,28.67-1.92,14.76-1.54,54.4-3.46,69.17-.85,6.56-1.7,12,.06,18.49a81.71,81.71,0,0,0,6.07,15.59c10.17,19.88,28.55,36.65,51.31,45.82a13.52,13.52,0,0,0,5.88,1.33c3.25-.22,5.76-2.49,7.86-4.66a156,156,0,0,0,14.12-16.74c3.71-5.08,7.11-10.42,8.86-16.24,2.3-7.61,1.67-15.63,1-23.48C1526.13,934.07,1523.51,908.58,1527,882.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M1525.83,889.22l-79.33-24.63c-13.9,62.49,38.25,89.32,81.55,92.85C1527.47,940.94,1524,905.65,1525.83,889.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6c8e8",
    d: "M1434.78,907c-34.78,17.67-52.2,57-66.67,91.46-15.2,19.09,26.78,28.29,39,35.85a182.58,182.58,0,0,1-60.06,10.35,552.87,552.87,0,0,0,90.06,227.88q3.39-136.95-.42-273.95C1435.34,968.21,1435.72,937.3,1434.78,907Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b6ae2",
    d: "M2613,433.56l-64-12.66a43.1,43.1,0,0,1-25.53-15.67l-24.75-31.54A35.79,35.79,0,0,0,2470.54,360h-168.6a35.78,35.78,0,0,0-28.14,13.69L2249,405.23a43.07,43.07,0,0,1-25.53,15.67l-64,12.66a76.46,76.46,0,0,0-61.6,74l-7.49,587.65a82.17,82.17,0,0,0,29.39,64.06c36.89,30.91,110.26,73.94,232.4,73.32v36.48a38.59,38.59,0,0,0,77.18,0v-36.52c116.67-1.52,187.29-43.15,223.25-73.28a82.18,82.18,0,0,0,29.4-64.06l-7.49-587.65A76.47,76.47,0,0,0,2613,433.56Zm-226.72,26.12a31.28,31.28,0,1,1,31.28-31.27A31.27,31.27,0,0,1,2386.24,459.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a094fc",
    d: "M2614.16,562.18c-187.24-23.15-355.36-9.58-456.23,4.12a29.23,29.23,0,0,0-25.42,28.52l-6,466.07a71.31,71.31,0,0,0,25.8,55.78c33.39,27.74,100.8,66.69,214.06,63.69q19.86-.52,39.71,0c113.26,3,180.68-35.95,214.06-63.69a71.29,71.29,0,0,0,25.81-55.78l-6-470.14A29.26,29.26,0,0,0,2614.16,562.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e74a60",
    d: "M2386.72,780.69l-232.36-58.31-.15-.23-4,317a65.57,65.57,0,0,0,23.46,51.12c30.34,25.43,91.62,61.13,194.56,58.37q18-.48,36.09,0c102.95,2.76,164.22-32.94,194.57-58.37a65.6,65.6,0,0,0,23.46-51.12l-3.74-293.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b32e69",
    d: "M2469.69,713.89c-117.36,66.11-315.33,8.49-315.33,8.49S2416,883.85,2555,811.71C2690.27,741.47,2587.05,647.77,2469.69,713.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174.49,
    height: 174.49,
    x: 2171.53,
    y: 665.72,
    fill: "#f3fcff",
    rx: 14.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2562.75,594.12h16.52a23.24,23.24,0,0,1,23.24,23.24V1045a23.24,23.24,0,0,1-23.24,23.24h-16.52a23.23,23.23,0,0,1-23.23-23.23V617.36A23.24,23.24,0,0,1,2562.75,594.12Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.25,
    height: 8.05,
    x: 2190.89,
    y: 698.38,
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.25,
    height: 8.05,
    x: 2190.89,
    y: 726.91,
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.25,
    height: 8.05,
    x: 2190.89,
    y: 755.45,
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 134.25,
    height: 8.05,
    x: 2190.89,
    y: 783.98,
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03458",
    d: "M2367.78,1307.28a9.09,9.09,0,0,0,9.09,9.08h27.53a9.09,9.09,0,0,0,9.08-9.08v-19.55h-45.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d3d3d",
    d: "M2883,1706.09c-1.24,22.15,24.62,44.31,104.63,56.62s306.52,19.7,348.37,32,45.55,51.7,78.79,50.47,51.66-47.88,52.52-87c.82-37.34-16.82-57-16.82-57S2884.21,1683.93,2883,1706.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e6e6e",
    d: "M3401.64,1684.34c-21.34-2.46-176.45-9.85-176.45-9.85s-264.25,4.92-303.64,8.21-49.24,20.51-40.22,27.9,99.3,18.05,199.43,26.26,266.71-11.9,313.49-16.41c36-3.47,58.27-11.49,56.22-18.88C3447.61,1691.29,3423,1686.8,3401.64,1684.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b32e69",
    d: "M3017.8,549.11l-43.24,79.39S2879,806.12,2909.7,881.87c.31.76.62,1.51.94,2.25,40.26,94.57,174.06,94.57,214.33,0,.32-.74.63-1.49.94-2.25C3156.63,806.12,3061,628.5,3061,628.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e74a60",
    d: "M3017.8,549.11l-43.24,79.39S2895,776.37,2904.41,859.81c55,53.61,154.47,40.8,188.22-38.47.31-.74.63-1.49.93-2.25,22-54.34-20.92-161.11-47-217.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.81,
    height: 29.8,
    x: 2999.74,
    y: 798.74,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.7,
    height: 26.18,
    x: 2969.04,
    y: 772.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.81,
    height: 29.98,
    x: 2999.74,
    y: 742.58,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.52,
    height: 26.18,
    x: 3027.55,
    y: 772.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.81,
    height: 26.18,
    x: 2999.74,
    y: 772.56,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141f35",
    d: "M1553.61,675.11c-1.82-7.29-11.84-16.85-28.7-17.77s-31.44,13.22-31.44,13.22-5.92-5.47-12.76-5.93-11.39,10.94-11.39,10.94-10.93-15-35.08-9.11-51.37,42.89-51.37,42.89c-45,9.88,7.14,171.77,55.13,159.15L1562.24,764c7.32,0,3.22-17.36,3.22-17.36,13.67-5.47,10.93-31.9,10.93-31.9s9.39-6.83,7.75-21.41C1580.5,661,1553.61,675.11,1553.61,675.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M1561.05,761.69c-.68-2.76-1.31-5.52-2.13-8.25-16.22-53.78-49-69.74-101.32-61.12-63.87,10.53-71.06,84.2-56.72,130.64,1.49,4.84,27.56,6.63,29.14,11.3,0,0-7,77.32,63.26,91.38,8.33,1.67,38.11,5.24,44.27-1.42,54-58.4,25.84-126.21,25.84-126.21C1566.82,790.65,1564.25,774.7,1561.05,761.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M1563.75,797.08c-10.82,10-17.76,25.28-17.76,42.46s6.89,32.37,17.65,42.36c16.07-44.55-.25-83.89-.25-83.89A9.42,9.42,0,0,0,1563.75,797.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M1433.53,813.18c-9.58,0-18.14,5.46-23.94,14.05,8.23,2.2,19.41,4,20.43,7,0,0-2.82,31.36,13.27,57.77,12.69-5.26,21.87-20.47,21.87-38.44C1465.16,831.27,1451,813.18,1433.53,813.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M1478.36,854l-2,2.31c14.52,12.48,28,14.73,36.79,14.37a33.41,33.41,0,0,0,10.6-2l-1.16-2.82C1522.41,866,1501.7,874.05,1478.36,854Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e4c23",
    d: "M1460.67,780.17c-6.74,4.13-4.24,8.71-3.22,10.22.6.88,3.11-.54,9.36-2.25,13.34-3.63,19.14-1.86,21.55-6.06,1.42-2.47,1.16-6.13-.61-7.9C1483.3,769.73,1461.56,779.63,1460.67,780.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e4c23",
    d: "M1552.16,773.28c-.76-.36-17.58-5.35-20.06-.78-1,1.82-.52,5.11,1,7.12,2.57,3.39,6.55,1,17.14,2.38,5,.65,7.1,1.56,7.38.7C1558.1,781.21,1557.94,776,1552.16,773.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M1477.19,804.68c-2.2.58-3.26,3.85-2.35,7.31s3.42,5.79,5.63,5.22,3.26-3.85,2.36-7.31S1479.4,804.1,1477.19,804.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M1541,796.57c-2,.53-2.91,3.75-2,7.2s3.27,5.82,5.28,5.29,2.91-3.74,2-7.19S1543,796.05,1541,796.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141f35",
    d: "M1566.35,686.62c-29.08-8.76-78.14-26.55-125,1s-59.7,61.27-66.69,71.83c-8.94,13.51,18.17,66.63,36.06,98.62,5.71,10.21,16.11,8.27,20.45-2.58l-2.08-5.06,4.06-21.78,2.71-81.5s89,4.5,111.57-16.57a60,60,0,0,1,11.46,22.89S1595.42,695.39,1566.35,686.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M1406.19,806.63c-14,4.48-21.4,20.71-16.44,36.25s20.36,24.51,34.4,20,21.39-20.71,16.43-36.25S1420.22,802.15,1406.19,806.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M1414.69,822.75a14.73,14.73,0,0,0-11.41,1.27l1.58,2.61a11.81,11.81,0,0,1,8.93-1c3.47,1.13,6.41,4.14,8.74,8.94-3.44.83-10.39,3.1-12.21,8.14l2.87,1c1.48-4.11,9-6.12,11.75-6.55l1.93-.3-.76-1.8C1423.29,828.44,1419.45,824.28,1414.69,822.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141f35",
    d: "M1432.6,744l.92,77.91c28.5-5.12,6.41-93.58,6.41-93.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M1516.71,812.77l-.56,3c7.31,1.37,18.22,4.59,19.56,7.48a.72.72,0,0,1,0,.77c-3.17,5.59-11.37,10.52-11.45,10.57l1.56,2.62c.36-.22,9-5.38,12.54-11.68a3.72,3.72,0,0,0,.16-3.56C1536,816.62,1519.91,813.36,1516.71,812.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f19a6d",
    points: "3178.13 1272.23 3266.36 1268.45 3266.42 1137.7 3178.13 1166.66 3178.13 1272.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#322924",
    d: "M3178.13,1201.76a49,49,0,0,0,18.75,4.07h3.51c13.92,0,29.57-7.12,39.93-15.93a26.39,26.39,0,0,0,9-20.05h-71.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3237.93,1001c-52.75-9.6-85.54,20.93-94.34,69.3,0,0-1.85,33.6-2.19,36.14-.05.34-20.38,53.7,24.47,102,2.53,2.73,6.3,3.61,10.09,4.26,78.91,13.56,83.11-64.29,83.11-64.29,1.33-3.86,34.43-42.08,35.19-46.2C3303.06,1053.82,3290.68,1010.6,3237.93,1001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3197.13,1229.89a15.4,15.4,0,0,1-.1,1.66l68.66.41.67-111.42-68.57-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52261f",
    d: "M3202.35,999.35c-37,5.85-74.74,33.68-75.1,70.87a29.16,29.16,0,0,0,31.23-13.77c4.28-7.29,9.11-15,12.88-19.69l22.44,27.2a73.62,73.62,0,0,0,36.63,24.23c11,3.1,23.52,3.83,33.61-3,0,0-16.63,49-2.73,54.08,0,0,54.35-2.34,43.16-70.68S3239.38,993.5,3202.35,999.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#383939",
    d: "M3204.77,1153.52a23.27,23.27,0,0,0-7.75,1.93,63.61,63.61,0,0,1-24.06,4.29,28.43,28.43,0,0,0-4.53.18,8.13,8.13,0,0,0-2.26.86c-3,1.9-2.88,5.77-1.73,8.66,2,5,6.41,9.11,11.85,11.49a26.1,26.1,0,0,0,11.05,2.08,28.6,28.6,0,0,0,22-11.71,21.49,21.49,0,0,0,1.82-3.19c1.79-4.11,2.17-9-.67-12.39C3209.16,1154,3207.16,1153.44,3204.77,1153.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3197,1155.45a63.61,63.61,0,0,1-24.06,4.29,28.43,28.43,0,0,0-4.53.18c.07,1.9.44,3.81,1.81,5.06s3.39,1.55,5.26,1.67a53.36,53.36,0,0,0,23.11-3.7c2-.76,4.08-1.77,5.26-3.62a8.52,8.52,0,0,0,.9-5.81A23.27,23.27,0,0,0,3197,1155.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1d38",
    d: "M3188.15,1171.74c-4.83,1.71-9.56,4.82-11.86,9.19a26.1,26.1,0,0,0,11.05,2.08,28.6,28.6,0,0,0,22-11.71A31.76,31.76,0,0,0,3188.15,1171.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52261f",
    d: "M3229.06,1089c-.73-.45-18.7-8.75-22.4-5.09-1.47,1.46-1.71,4.49-.54,6.55,2,3.48,6.79,2,17.81,5.11,5.18,1.45,7.25,2.64,7.75,1.91C3232.53,1096.21,3234.62,1092.44,3229.06,1089Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52261f",
    d: "M3151.23,1083.26c-5.07,1.84-5.05,4.85-4.57,6,.27.67,2.14.07,6.56-.22,9.4-.61,13,1.37,15.21-1.1a4.83,4.83,0,0,0,.68-5.37C3166.74,1079,3151.89,1083,3151.23,1083.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee6a4a",
    d: "M3178.05,1212.81l.18,26.8c33-4.35,63.91-59.06,63.91-59.06C3222.42,1210.6,3178.05,1212.81,3178.05,1212.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M3176.61,1119.83l-1.91-2.1c-6.13,5.57-8.78,10.72-7.88,15.33,1.19,6,8,8.52,8.24,8.63l1-2.67c-.05,0-5.56-2.09-6.42-6.52C3168.92,1129,3171.35,1124.61,3176.61,1119.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f19a6d",
    d: "M3279.3,1111.64c-14.1-3.17-28.37,6.91-31.89,22.51s5.07,30.84,19.17,34,28.37-6.91,31.89-22.52S3293.4,1114.81,3279.3,1111.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M3272.4,1128.18c-4.49,1.9-7.87,6.28-10.05,13l-.56,1.73,1.82.12c2.75.19,10.29,1.52,12.1,5.45l2.58-1.2c-2.22-4.78-9.28-6.37-12.66-6.87,1.88-5,4.51-8.2,7.84-9.62a11.73,11.73,0,0,1,8.87.18l1.26-2.54A14.41,14.41,0,0,0,3272.4,1128.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M3226.7,1155.61a32.88,32.88,0,0,0,20.58,30.66c11.24-17.92,12.33-37.79,12.33-37.79a146.35,146.35,0,0,0,.16-25.54A32.88,32.88,0,0,0,3226.7,1155.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7c59",
    d: "M3138.59,1117.25a102.84,102.84,0,0,0,4,53.43,32.8,32.8,0,0,0-4-53.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M3216.9,1107.1c-2-.4-4.21,2.07-4.91,5.53s.37,6.59,2.38,7,4.22-2.07,4.92-5.53S3218.92,1107.51,3216.9,1107.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38261f",
    d: "M3158.35,1103.21c-1.83-.37-3.84,1.88-4.48,5s.34,6,2.18,6.38,3.84-1.89,4.47-5S3160.19,1103.58,3158.35,1103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#814530",
    d: "M3243.42,1024.14c-21.37-8.87-45-7.84-43-7.42,18.65,4.11,31.06,11.08,30.72,12.77-.39,1.94-43.14-5.68-43.61-3.4-.26,1.23,12.55,2.56,28.45,11,17.4,9.24,29.14,22,31.54,19.87,1.27-1.15-1.55-5.21-.25-6.28,2.94-2.42,20.89,15.73,23,13.83,1.17-1-3.79-7.13-2.23-8.86,2.26-2.51,15.21,7.57,16.5,6.09C3286.22,1059.83,3270.76,1035.51,3243.42,1024.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1792.66,
    cy: 800.1,
    r: 106.02,
    fill: "#ad6ad2",
    transform: "rotate(-45 1792.664 800.104)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ad6ad2",
    points: "1727.73 920.55 1769.51 891.66 1721.39 868.62 1727.73 920.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1840.4,786.13a14,14,0,1,0,14,14A14,14,0,0,0,1840.4,786.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1795,786.13a14,14,0,1,0,14,14A14,14,0,0,0,1795,786.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1747.28,786.13a14,14,0,1,0,14,14A14,14,0,0,0,1747.28,786.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ec9bc",
    d: "M3664.08,984.58H3493a35.68,35.68,0,0,0-35.68,35.68v195.52a6.6,6.6,0,0,0,11.36,4.58l35.39-36.74a16.72,16.72,0,0,1,12-5.12h142.27a34.71,34.71,0,0,0,34.7-34.7V1013.62A29,29,0,0,0,3664.08,984.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3617.24,1070.22a14,14,0,1,0,14,14A14,14,0,0,0,3617.24,1070.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3571.86,1070.22a14,14,0,1,0,14,14A14,14,0,0,0,3571.86,1070.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3524.12,1070.22a14,14,0,1,0,14,14A14,14,0,0,0,3524.12,1070.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadBg);
export default __webpack_public_path__ + "static/media/headBg.989c39b0138482936968be3a92a9c519.svg";
export { ForwardRef as ReactComponent };